<!-- page-not-found.component.html -->
<nz-layout>
  <div class="page-not-found-container">
    <div class="content">
      <nz-header>
        <img width="150px" height="100px" src="/assets/images/logo-black.svg" alt="Suprema logo" />
      </nz-header>
      <div class="warn-icon">😕</div>
      <nz-content>
        <span class="title">Erro 403, você não está logado!</span>
        <div nz-result-extra>
          <div class="button-container">
            <button nz-button nzType="primary" routerLink="/login">Acessar o sistema</button>
            <button nz-button routerLink="/">Página inicial</button>
          </div>
        </div>
      </nz-content>
    </div>
  </div>
</nz-layout>
